<template>
  <div board>
    <div class="wrapper">
      <top-visual type="board">
        <h2>NEWS</h2>
        <h3>가인패드 소식을 지금 확인해보세요</h3>
      </top-visual>
      <section class="list">
        <ul>
          <li v-for="item in listData" :key="item.SQ">
            <a :href="item.VDO" target="_blank">
              <p>{{ item.TITLE }}</p>
              <p v-html="contParse(item.SUB)"></p>
            </a>
          </li>
        </ul>
        <a v-if="pageResult && pageResult.pageNo < pageResult.pageCount" @click="nextPage" class="more">more</a>
      </section>
    </div>
  </div>
</template>

<style lang="less" scoped>
  @import "../less/gynpad";
  @import "../less/asset";
  [board] { .rel; overflow:hidden; }

  .list { .rm-t(30); .rm-h(25); .rm-b(30);
    li { .rm-t(20); .border(#e6e6e6);
      a { .block; .rel; padding:25px 20px;
        p:nth-child(1) { .fs(1.25rem); .bold;  }
        p:nth-child(2) { .rm-t(15); }
      }
    }
    .more { .block; .ir; .rm-v(30); .rh(50); .contain('@{story}/more.png'); .bg-c; }
  }

  @media (min-width: @screen-lg-min) {
    [board] { padding-bottom:130px; }

    .list { margin-top:30px; padding:0 40px; max-width:1280px; .m-hc; .border-box;
      ul { margin:0 -15px; .cf; }
      li { .block; width:33.33%; padding:0 15px; .border-box; margin-top:50px; border:0;
        a { .border(#e6e6e6); height:230px; padding:40px 30px; .border-box;
          p:nth-child(1) { .fs(20px); }
          p:nth-child(2) { margin-top:25px; .fs(16px); }
        }
        a:hover:before { content:''; .block; .lb(0,-20px); .wh(24px,20px); background:url('@{common}/news-li-over-bg.png'); }
        a:hover:after { content:''; .block; .lt; .wh(100%); background:#f85c70 url('@{common}/news-li-over.png') center center no-repeat; }
      }
      .more { height:88px; }
    }
  }

</style>

<script>
import axios from 'axios';
import handler from '../util/ErrorHandler';
import TopVisual from '../components/TopVisual.vue';
import { contParse } from '../util';

export default {
  name: 'News',
  components: { TopVisual },
  data() {
    return {
      pageResult: null,
      listData: [],
      pageNo: 1,
      perPage: 6,
      search: '',
    };
  },
  methods: {
    updateList() {
      axios.get('/api/board/list', {
        params: {
          pageNo: this.pageNo, perPage: this.perPage, TYPE: 'NEWS', SEARCH: this.search,
        },
      })
        .then(({ data }) => {
          this.listData = this.listData.concat(data.list);
          this.pageResult = data.paging;
        })
        .catch(handler());
    },
    nextPage() {
      this.pageNo += 1;
      this.updateList();
    },
    contParse(org) {
      return contParse(org);
    },
  },
  mounted() {
    this.updateList();
  },
};
</script>




// WEBPACK FOOTER //
// src/views/News.vue